module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_15-94010e50e756fedbfbbaa95dbcccf999.png";